import React from "react";

function Profile () {
    return (
        <p>Profile</p>
    )
}

export default Profile;